var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"location"},[_c('nova-select',{staticClass:"m-b-2",attrs:{"items":_vm.courses},on:{"change":_vm.change},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }